
import DocsModel from '../models/DocsModel'

const docs = (state, action) => {

    if (!state) {
        state = {
            items: [],
            data: DocsModel.dispense(),
            complete: false,
            error: ''
        }
    }

    switch (action.type) {
        case 'PUBLIC_DOCS_LOAD':
        return {
            ...state,
            items: action.items
        }
        case 'DOCS_OPEN_FORM':
        return {
            data: action.formData,
            complete: false,
            error: ''
        }
        case 'DOCS_UPDATE_FORM':
        return {
            ...state,
            data: action.formData,
            complete: action.complete,
            error: action.error,
            caop: null
        }
        case 'DOCS_OPEN_VIEW':
        return {
            ...state,
            data: action.data,
            complete: false,
            error: ''
        }
        default:
        return state
    }
}

export default docs



// WEBPACK FOOTER //
// ./src/reducers/docs.js